import React from 'react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
export function Hero() {
  return <Section className="min-h-[80vh] flex items-center justify-center pt-10 md:pt-24 pb-24" data-id="element-130">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-6 items-center" data-id="element-131">
        {/* Text Content - Left */}
        <div className="flex flex-col items-center text-center" data-id="element-132">
          <span className="inline-block px-4 py-1.5 mb-4 md:mb-6 text-sm font-medium tracking-wider text-brand-primary uppercase bg-brand-primary/10 rounded-full border border-brand-primary/20" data-id="element-133">
            Psihoterapie Integrativă & Coaching
          </span>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-text mb-6 md:mb-8 leading-tight" data-id="element-134">
            De la anxietate și frică, la{' '}
            <span className="text-brand-primary italic" data-id="element-135">
              liniște interioară
            </span>{' '}
            și încredere.
          </h1>

          {/* Photo - shown only on mobile, between title and subtitle */}
          <div className="relative flex items-start justify-center md:hidden mb-6 w-full" data-id="element-136">
            {/* Large gradient blob behind photo */}
            <div className="absolute -top-8 -right-8 w-[105%] h-[105%] bg-gradient-to-br from-brand-primary/10 via-brand-secondary/15 to-brand-accent/10 rounded-full blur-3xl z-0" data-id="element-137" />

            {/* Photo container */}
            <div className="relative z-10 w-full max-w-xs aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl ring-4 ring-white/80" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/oKguZ66tL1ePYmfTDvPuKU/WhatsApp_Image_2026-05-04_at_12.09.30.jpg" alt="Daniela Sămărtinean" className="w-full h-full object-cover object-top" data-id="element-139" />

              {/* Gradient overlay bottom for badge readability */}
              <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-black/40 to-transparent" data-id="element-140" />

              {/* Name badge overlay */}
              <div className="absolute bottom-5 left-5 bg-white/95 backdrop-blur-sm text-brand-text px-4 py-2.5 rounded-xl shadow-lg border border-brand-primary/10" data-id="element-141">
                <p className="font-bold text-sm" data-id="element-142">Daniela Sămărtinean</p>
                <div className="flex items-center gap-2 mt-1" data-id="element-143">
                  <div className="w-4 h-0.5 bg-brand-primary rounded-full" data-id="element-144" />
                  <p className="text-[10px] text-brand-primary font-medium uppercase tracking-wide" data-id="element-145">
                    Psihoterapeut Integrativ
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl leading-relaxed" data-id="element-146">
            Un proces profund și practic pentru oameni copleșiți de gânduri
            repetitive, neliniște, frici sau dependențe emoționale, care vor
            să-și armonizeze mintea cu corpul și să-și regăsească echilibrul
            interior prin Metoda 3S (Știință · Suflet · Spirit).
          </p>

          <div className="flex flex-col items-center space-y-4" data-id="element-147">
            <a href="https://wa.me/40742236028" data-id="element-148">
              <Button variant="accent" size="lg" className="shadow-lg shadow-brand-accent/20 hover:shadow-brand-accent/30 transition-all transform hover:-translate-y-1" data-id="element-149">
                Rezervă Sesiunea CADOU de Evaluare
              </Button>
            </a>
            <span className="text-sm text-gray-500 font-medium" data-id="element-150">
              Confidențial. Clar. Fără judecată.
            </span>
          </div>
        </div>

        {/* Photo - Right (desktop only) */}
        <div className="relative hidden md:flex items-start justify-center" data-id="element-151">
          {/* Large gradient blob behind photo */}
          <div className="absolute -top-8 -right-8 w-[105%] h-[105%] bg-gradient-to-br from-brand-primary/10 via-brand-secondary/15 to-brand-accent/10 rounded-full blur-3xl z-0" data-id="element-152" />

          {/* Decorative dots top-right */}
          <div className="absolute -top-5 right-2 grid grid-cols-4 gap-2 z-20" data-id="element-153">
            {[...Array(16)].map((_, i) => <div key={i} className="w-2 h-2 rounded-full bg-brand-accent/40" data-id="element-154" />)}
          </div>

          {/* Decorative dots bottom-left */}
          <div className="absolute -bottom-4 left-4 grid grid-cols-3 gap-2 z-20" data-id="element-155">
            {[...Array(9)].map((_, i) => <div key={i} className="w-2 h-2 rounded-full bg-brand-primary/30" data-id="element-156" />)}
          </div>

          {/* Floating circles */}
          <div className="absolute top-12 -right-4 w-10 h-10 bg-brand-accent/25 rounded-full z-20" data-id="element-157" />
          <div className="absolute -bottom-6 right-16 w-14 h-14 bg-brand-primary/10 rounded-full z-0" data-id="element-158" />
          <div className="absolute -top-4 left-12 w-10 h-10 bg-brand-secondary/20 rounded-full z-0" data-id="element-159" />

          {/* Sparkle SVGs */}
          <svg className="absolute -top-6 right-20 w-10 h-10 text-brand-accent/50 z-20" viewBox="0 0 24 24" fill="currentColor" data-id="element-160">
            <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" data-id="element-161" />
          </svg>
          <svg className="absolute bottom-8 left-2 w-7 h-7 text-brand-primary/35 z-20" viewBox="0 0 24 24" fill="currentColor" data-id="element-162">
            <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" data-id="element-163" />
          </svg>

          {/* Decorative arc bottom-right */}
          <div className="absolute -bottom-3 right-2 w-20 h-20 border-b-2 border-r-2 border-brand-accent/20 rounded-br-[2rem] z-20" data-id="element-164" />

          {/* Photo container */}
          <div className="relative z-10 w-full max-w-md aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl ring-4 ring-white/80" data-id="element-165">
            <img src="https://cdn.magicpatterns.com/uploads/oKguZ66tL1ePYmfTDvPuKU/WhatsApp_Image_2026-05-04_at_12.09.30.jpg" alt="Daniela Sămărtinean" className="w-full h-full object-cover object-top" data-id="element-166" />

            {/* Gradient overlay bottom for badge readability */}
            <div className="absolute bottom-0 left-0 right-0 h-28 bg-gradient-to-t from-black/40 to-transparent" data-id="element-167" />

            {/* Name badge overlay */}
            <div className="absolute bottom-5 left-5 bg-white/95 backdrop-blur-sm text-brand-text px-4 py-2.5 rounded-xl shadow-lg border border-brand-primary/10" data-id="element-168">
              <p className="font-bold text-sm" data-id="element-169">Daniela Sămărtinean</p>
              <div className="flex items-center gap-2 mt-1" data-id="element-170">
                <div className="w-4 h-0.5 bg-brand-primary rounded-full" data-id="element-171" />
                <p className="text-[10px] text-brand-primary font-medium uppercase tracking-wide" data-id="element-172">
                  Psihoterapeut Integrativ
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}